import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ng6-toastr-notifications';
// import { TranslateLoader, TranslateModule,TranslateService } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TruncatePipe } from "./pipe/truncate.pipe";
import { CKEditorModule } from 'ng2-ckeditor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { LoginComponent } from './Auth/login/login.component';
import { ChangePasswordComponent } from './Auth/change-password/change-password.component';
import { HeaderComponent } from './Componants/header/header.component';
import { SidebarComponent } from './Componants/sidebar/sidebar.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { FooterComponent } from './Componants/footer/footer.component';
import { UserListComponent } from './Pages/user-list/user-list.component';
import { StaticListComponent } from './Pages/static-list/static-list.component';
import { StaticEditComponent } from './Pages/static-edit/static-edit.component';
import { TransactionComponent } from './Pages/transaction/transaction.component';
import { MasterListComponent } from './Pages/master-list/master-list.component';
import { MasterCrudComponent } from './Pages/master-crud/master-crud.component';
import { ReportComponent } from './Pages/report/report.component';
import { UserDEtailComponent } from './Pages/user-detail/user-detail.component';
import { InqueryListComponent } from './Pages/inquery-list/inquery-list.component';
import { MasterCrudUpdateComponent } from './Pages/master-crud-update/master-crud-update.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { FaqAddEditComponent } from './Pages/faq-add-edit/faq-add-edit.component';
import { RequestComponent } from './Pages/request/request.component';
import { DetailComponent } from './Pages/detail/detail.component';
import { CountryComponent } from './Pages/country/country.component';
import { AddCityComponent } from './Pages/add-city/add-city.component';
import { AppVersionComponent } from './Pages/app-version/app-version.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    ChangePasswordComponent,
    HeaderComponent,
    SidebarComponent,
    ProfileComponent,
    FooterComponent,
    UserListComponent,
    StaticListComponent,
    StaticEditComponent,
    TransactionComponent,
    MasterListComponent,
    MasterCrudComponent,
    ReportComponent,
    UserDEtailComponent,
    InqueryListComponent,
    MasterCrudUpdateComponent,
    FaqComponent,
    FaqAddEditComponent,
    RequestComponent,
    DetailComponent,
    CountryComponent,
    AddCityComponent,
    AppVersionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TruncatePipe,
    NgxLoadingModule.forRoot({}),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    CKEditorModule,
    HttpClientModule,
    NgxPaginationModule, 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
